<template>
    <div class="relative">
        <div class="absolute top-0 left-0 w-full">
            <div class="flex gap-4 justify-between">
                <ProductFlags :data="data" />

                <ProductBrandBadge
                    :brands="props?.data?.customFields?.brand"
                    :alt="data?.customFields?.brand_name"
                    size="lg"
                    class="ml-auto"
                />
            </div>
        </div>

        <div class="w-full h-full">
            <LayoutImage
                v-if="selectedMedia"
                :key="selectedMedia.id"
                :media="selectedMedia"
                :lazy-load="false"
                :preload="true"
                sizes="100vw sm:50vw md:800px"
                fit="fit"
                class="w-full h-full max-h-[530px] object-contain"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import {computed, onBeforeUnmount, ref, type Ref} from 'vue'
import {useNuxtApp} from '#imports'
import type {HblMedia, HblProduct} from '@/utils/types'
import placeholderImage from '@/assets/product/placeholder-image.png'

interface ProductDetailMediaGalleryProps {
    data: HblProduct | undefined,
    mediaData?: HblMedia[] | HblMedia,
}

const props = withDefaults(defineProps<ProductDetailMediaGalleryProps>(), {
    mediaData: () => {
        return {
            alt: 'Placeholder Image',
            title: 'Placeholder Image',
            url: placeholderImage,
            thumbnails: []
        }
    }
})

const media: Ref<HblMedia[] | HblMedia> = ref(props.mediaData)

const {$hblBus} = useNuxtApp()
// @ts-ignore
$hblBus.$on('productVariantChanged', eventListenerMediaGallery)

// @ts-ignore
function eventListenerMediaGallery({data}) {
    const {media: mediaData} = data
    media.value = mediaData
}

onBeforeUnmount(() => {
    // @ts-ignore
    $hblBus.$off('productVariantChanged', eventListenerMediaGallery)
})

const selectedMedia = computed(() => {
    if (media.value?.length >= 2) {
        // @ts-ignore
        return media.value[1]
    } else if (media.value?.length === 1) {
        // @ts-ignore
        return media.value[0]
    } else {
        return null
    }
})
</script>
